import angular from 'angular';
import template from './call-frames-mic.html';
class CallFramesMicController {
    constructor($translate) {
        this.$translate = $translate;
    }
    $onInit() {
        if (this.onInit) {
            this.onInit();
        }
    }
    getTitle() {
        if (this.noTitle)
            return undefined;
        if (this.isOff) {
            return this.$translate.instant('video-chat.actions.muted');
        }
        else if (!this.disabled) {
            return this.muteText;
        }
    }
    onClick($event) {
        $event.stopImmediatePropagation();
        if (this.isOff || this.disabled)
            return;
        this.onToggle();
    }
}
const callFramesMicComponent = {
    template,
    bindings: {
        isOff: '<',
        muteText: '@',
        onToggle: '&',
        onInit: '&',
        disabled: '<',
        noTitle: '<?',
        streamId: '<',
        disableTab: '<',
    },
    controller: CallFramesMicController,
};
export default angular
    .module('doxy.videoChat.callFrames.callFramesMic', [])
    .component('callFramesMic', callFramesMicComponent).name;
